var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecoveryEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 3.59921C7.36041 3.59921 3.59961 7.36001 3.59961 11.9992C3.59961 14.3304 4.54928 16.4399 6.08286 17.9617M10.7996 7.1992L13.1996 3.59921L9.59959 1.19922M11.9996 20.3617C16.6388 20.3617 20.3996 16.6009 20.3996 11.9617C20.3996 9.63048 19.4499 7.52105 17.9163 5.99918M13.1996 16.7992L10.7996 20.3992L14.3996 22.7992",
    stroke: "#0F0F0F",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40027 9.99922L12.0003 11.9992L15.6003 9.99922M8.40027 9.19922H15.6003V14.7992H8.40027V9.19922Z",
    stroke: "#0F0F0F",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecoveryEmailIcon);
export default __webpack_public_path__ + "static/media/recoveryEmailIcon.030b374d96a8ed64a8f4e02ef3d63f98.svg";
export { ForwardRef as ReactComponent };